import { apiClient } from '@/lib/api/client'
import type { FESchedule } from '@/types/parentTicket'

export interface FEScheduleListFilters {
  date_from: string
  date_to: string
  fe_user_id?: number | number[] | string
  cluster_id?: number
  region_id?: number
  status?: string
}

export const feScheduleService = {
  async listSchedules(filters: FEScheduleListFilters): Promise<FESchedule[]> {
    const params: Record<string, string | number> = {
      date_from: filters.date_from,
      date_to: filters.date_to,
    }

    if (filters.fe_user_id != null && filters.fe_user_id !== '') {
      params.fe_user_id = Array.isArray(filters.fe_user_id)
        ? filters.fe_user_id.join(',')
        : String(filters.fe_user_id)
    }
    if (filters.cluster_id != null) {
      params.cluster_id = filters.cluster_id
    }
    if (filters.region_id != null) {
      params.region_id = filters.region_id
    }
    if (filters.status) {
      params.status = filters.status
    }

    const response = await apiClient.get<{ success: boolean; data?: FESchedule[]; message?: string }>(
      '/helpdesk/fe-schedules',
      { params },
    )

    if (!response.data?.success) {
      throw new Error(response.data?.message || 'Failed to load FE schedules')
    }

    return response.data.data ?? []
  },
}
